import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line: importsNotUsedAsValues
import 'react';
import classNames from 'classnames';
const ActionBarItemListSeparator = (_a) => {
    var { className } = _a, remainingProps = __rest(_a, ["className"]);
    const classes = classNames('ActionBarItemListSeparator', className);
    return _jsx("hr", Object.assign({}, remainingProps, { className: classes }));
};
export default ActionBarItemListSeparator;
